import { Pipe } from '@angular/core';
import { isEqual } from 'lodash';

@Pipe({ name: 'differentData' })
export class DifferentDataPipe {
  transform(value1: any, value2: any): boolean {
    return !isEqual(value1, value2);
  }
}
